import type { i18n as I18nInstance } from "i18next";

import { isPrrMode } from "../config";
import { PRR_PT_PT_OVERRIDES } from "./ptPT";

function collectOrphanKeys(
  overrides: Record<string, unknown>,
  source: Record<string, unknown> | undefined,
  path: string,
): string[] {
  if (!source) return [path];

  return Object.entries(overrides).flatMap(([key, value]) => {
    const current = path ? `${path}.${key}` : key;
    const sourceValue = source[key];

    if (value !== null && typeof value === "object") {
      return collectOrphanKeys(
        value as Record<string, unknown>,
        sourceValue as Record<string, unknown> | undefined,
        current,
      );
    }

    return sourceValue === undefined ? [current] : [];
  });
}

/**
 * Aplica os textos pt-PT sobre o bundle pt-BR do core.
 *
 * O `deep merge` do i18next mantém as chaves não sobrescritas, por isso um
 * merge futuro da develop que acrescente strings continua a funcionar.
 *
 * @returns número de namespaces atualizados (0 fora do modo PRR)
 */
export function applyPrrPtPtI18n(i18n: I18nInstance): number {
  if (!isPrrMode()) return 0;

  const deep = true;
  const overwrite = true;

  Object.entries(PRR_PT_PT_OVERRIDES).forEach(([namespace, resources]) => {
    if (import.meta.env.DEV) {
      const orphans = collectOrphanKeys(
        resources,
        i18n.getResourceBundle("pt-BR", namespace),
        "",
      );

      if (orphans.length > 0) {
        // Sinaliza chaves removidas/renomeadas no core após um merge da develop.
        console.warn(
          `[prr-i18n] chaves inexistentes no namespace "${namespace}":`,
          orphans,
        );
      }
    }

    i18n.addResourceBundle("pt-BR", namespace, resources, deep, overwrite);
  });

  return Object.keys(PRR_PT_PT_OVERRIDES).length;
}

export { PRR_PT_PT_OVERRIDES };
